import * as Sentry from '@sentry/react';
import posthog from 'posthog-js';

// Initialize Sentry
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

// Initialize PostHog
if (process.env.REACT_APP_POSTHOG_KEY) {
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: 'https://app.posthog.com',
    autocapture: false,
  });
}

export function trackEvent(name, properties = {}) {
  if (posthog.__loaded) {
    posthog.capture(name, properties);
  }
}

export function identifyUser(id, props = {}) {
  if (!id) return;
  if (posthog.__loaded) {
    posthog.identify(String(id), props);
  }
}

export function resetUser() {
  if (posthog.__loaded) {
    posthog.reset();
  }
}

export { posthog };
